import { toast } from 'react-toastify';

import Api from 'lib/api';

const api = Api.getInstance();

const ns = 'app/browse/';

export const LOAD_START = ns + 'LOAD_START';
export const LOAD_SUCCESS = ns + 'LOAD_SUCCESS';
export const LOAD_FAILURE = ns + 'LOAD_FAILURE';

export const VIEW_START = ns + 'VIEW_START';
export const VIEW_SUCCESS = ns + 'VIEW_SUCCESS';
export const VIEW_FAILURE = ns + 'VIEW_FAILURE';

export const SAVE_START = ns + 'SAVE_START';
export const SAVE_SUCCESS = ns + 'SAVE_SUCCESS';
export const SAVE_FAILURE = ns + 'SAVE_FAILURE';

export const REQUEST_START = ns + 'REQUEST_START';
export const REQUEST_SUCCESS = ns + 'REQUEST_SUCCESS';
export const REQUEST_FAILURE = ns + 'REQUEST_FAILURE';

export const LOAD_CATEGORIES_START = ns + 'LOAD_CATEGORIES_START';
export const LOAD_CATEGORIES_SUCCESS = ns + 'LOAD_CATEGORIES_SUCCESS';
export const LOAD_CATEGORIES_FAILURE = ns + 'LOAD_CATEGORIES_FAILURE';

export function load(query, paging = false) {
  return async dispatch => {
    dispatch({
      type: LOAD_START,
      payload: {
        paging: paging
      }
    });

    try {
      const response = await api.get('asks', { params: query });
      const { data } = response;

      if (data.success) {
        dispatch({
          type: LOAD_SUCCESS,
          payload: {
            ...data,
            paging: paging
          }
        });
      } else {
        dispatch({
          type: LOAD_FAILURE,
          payload: response
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: LOAD_FAILURE,
        payload: response
      });
    }
  };
}

export function loadCategories(dispatch) {
  return async dispatch => {
    dispatch({
      type: LOAD_CATEGORIES_START
    });

    try {
      const response = await api.get('categories');
      const { data } = response;

      if (data.success) {
        dispatch({
          type: LOAD_CATEGORIES_SUCCESS,
          payload: Object.values(data.data)
        });
      } else {
        dispatch({
          type: LOAD_CATEGORIES_FAILURE,
          payload: response
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured loading categories.');
      }

      dispatch({
        type: LOAD_CATEGORIES_FAILURE,
        payload: response
      });
    }
  };
}

export function view(askId) {
  return async dispatch => {
    dispatch({
      type: VIEW_START
    });

    try {
      const response = await api.get(`asks/${askId}`);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: VIEW_SUCCESS,
          payload: data.data
        });
      } else {
        toast.error('Unable to retrieve sponsorship.');
        dispatch({
          tyype: VIEW_FAILURE
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: VIEW_FAILURE,
        payload: response
      });
    }
  };
}

export function save(ask) {
  return async dispatch => {
    dispatch({
      type: SAVE_START,
      payload: ask.id
    });

    try {
      let saveData = {};

      if (!ask.saved) {
        let notes = window.prompt(
          'Enter some notes you would like to save with the sponsorship (optional)'
        );

        if (notes !== null) {
          notes = notes.trim();
          if (notes) {
            saveData.notes = notes;
          }
        }
      }

      const response = await api.post(`asks/save/${ask.id}`, saveData);
      const { data } = response;

      if (data.success) {
        if (ask.saved) {
          // if the ask was saved, it shouldn't be any more.
          toast.success('Saved sponsorship removed.');
        } else {
          toast.success('Sponsorship saved!');
        }

        dispatch({
          type: SAVE_SUCCESS,
          payload: ask.id
        });
      } else {
        dispatch({
          type: SAVE_FAILURE,
          payload: ask.id
        });
        toast.error('Unable to update saved sponsorship.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SAVE_FAILURE,
        payload: ask.id
      });
    }
  };
}

export function request(ask, postData = {}) {
  return async dispatch => {
    dispatch({
      type: REQUEST_START,
      payload: ask.id
    });

    try {
      const response = await api.post(
        `partnerships/request/${ask.id}`,
        postData
      );
      const { data } = response;

      if (data.success) {
        if (data.corporate_partnership) {
          toast.success('Sponsorship requested.');
        } else {
          toast.success('Sponsorship request canceled.');
        }

        dispatch({
          type: REQUEST_SUCCESS,
          payload: data.corporate_partnership
        });
      } else {
        dispatch({
          type: REQUEST_FAILURE
        });

        toast.error('Unable to complete request.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: REQUEST_FAILURE
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/browse/actions.js